<h2 mat-dialog-title style="text-align:center; margin-bottom: 16px;">Create Policy</h2>
<mat-dialog-content>

  <!--  ID -->

  <mat-form-field appearance="outline" class="form-field-stretch" color="accent" id="form-field-id">
    <mat-label>ID</mat-label>
    <input [(ngModel)]="policyDefinition.id" matInput required>
   <mat-icon matPrefix>fingerprint</mat-icon>
  </mat-form-field>

  <!--  Assigner / Assignee-->
  <!-- <div style="display: flex; gap: 20px;">

    <mat-form-field class="form-field form-field-half" color="accent" id="form-field-asignee">
      <mat-label>Assignee</mat-label>
      <mat-icon matPrefix>person</mat-icon>
      <input [(ngModel)]="policy.assignee" matInput>
    </mat-form-field>


    <mat-form-field class="form-field form-field-half" color="accent" id="form-field-assigner">
      <mat-label>Assigner</mat-label>
      <mat-icon matPrefix>supervisor_account</mat-icon>
      <input [(ngModel)]="policy.assigner" matInput>
    </mat-form-field>
  </div> -->


  <!-- Restriction Type Dropdown -->
  <mat-form-field class="form-field-stretch" color="accent">
    <mat-label>Permissions</mat-label>
    <mat-icon matPrefix>tune</mat-icon>
    <mat-select [(ngModel)]="restrictionType" (ngModelChange)="onRestrictionTypeChange()">
      <mat-option value="none">None</mat-option>
      <mat-option value="temporal">Temporal range</mat-option>
      <mat-option value="location">Location</mat-option>
      <mat-option value="purpose">Purpose</mat-option>
      <mat-option value="json">JSON</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Temporal range -->
  <div *ngIf="restrictionType === 'temporal'" style="display: flex; gap: 16px;">
    <mat-form-field class="form-field-half" color="accent">
      <mat-label>Start date</mat-label>
      <mat-icon matPrefix>event</mat-icon>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="temporalStart" (ngModelChange)="onTemporalRangeChange()" placeholder="Start date" readonly (click)="startPicker.open()" (keydown)="$event.preventDefault()">
      <mat-datepicker #startPicker panelClass="policy-date-picker"></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="form-field-half" color="accent">
      <mat-label>End date</mat-label>
      <mat-icon matPrefix>event_busy</mat-icon>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="temporalEnd" (ngModelChange)="onTemporalRangeChange()" placeholder="End date" readonly (click)="endPicker.open()" (keydown)="$event.preventDefault()">
      <mat-datepicker #endPicker panelClass="policy-date-picker"></mat-datepicker>
    </mat-form-field>
  </div>

  <!-- Location -->
  <div *ngIf="restrictionType === 'location'">
    <mat-form-field class="form-field-stretch" color="accent">
      <mat-label>Location</mat-label>
      <mat-icon matPrefix>public</mat-icon>
      <input matInput [(ngModel)]="locationValue" (ngModelChange)="onLocationChange()" placeholder="Location" />
    </mat-form-field>
  </div>

  <!-- Purpose -->
  <div *ngIf="restrictionType === 'purpose'">
    <mat-form-field class="form-field-stretch" color="accent">
      <mat-label>Purpose</mat-label>
      <mat-icon matPrefix>flag</mat-icon>
      <input matInput [(ngModel)]="purposeValue" (ngModelChange)="onPurposeChange()" placeholder="Purpose" />
    </mat-form-field>
  </div>

  <!-- Additional restrictions (solo para modo no JSON) -->
  <div *ngIf="restrictionType !== 'json'" style="display: flex; flex-direction: column; gap: 12px;">
    <div *ngFor="let extra of additionalRestrictions; let i = index" style="display: flex; flex-direction: column; gap: 12px; padding: 12px; border: 1px solid rgba(148, 163, 184, 0.35); border-radius: 16px;">
      <div style="display: flex; gap: 12px; align-items: center;">
        <mat-form-field class="form-field-stretch" color="accent" style="margin: 0;">
          <mat-label>Restriction {{ i + 2 }} type</mat-label>
          <mat-icon matPrefix>tune</mat-icon>
          <mat-select [(ngModel)]="extra.type" (ngModelChange)="onAdditionalRestrictionTypeChange(i)">
            <mat-option value="none">None</mat-option>
            <mat-option value="temporal">Temporal range</mat-option>
            <mat-option value="location">Location</mat-option>
            <mat-option value="purpose">Purpose</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="icon-btn">
          <button class="icon-button" mat-stroked-button color="warn" type="button" (click)="removeRestriction(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="extra.type === 'temporal'" style="display: flex; gap: 12px;">
        <mat-form-field class="form-field-half" color="accent">
          <mat-label>Start date</mat-label>
          <mat-icon matPrefix>event</mat-icon>
          <input matInput [matDatepicker]="startPickerExtra" [(ngModel)]="extra.temporalStart" (ngModelChange)="onAdditionalRestrictionChange()" placeholder="Start date" readonly (click)="startPickerExtra.open()" (keydown)="$event.preventDefault()">
          <mat-datepicker #startPickerExtra panelClass="policy-date-picker"></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="form-field-half" color="accent">
          <mat-label>End date</mat-label>
          <mat-icon matPrefix>event_busy</mat-icon>
          <input matInput [matDatepicker]="endPickerExtra" [(ngModel)]="extra.temporalEnd" (ngModelChange)="onAdditionalRestrictionChange()" placeholder="End date" readonly (click)="endPickerExtra.open()" (keydown)="$event.preventDefault()">
          <mat-datepicker #endPickerExtra panelClass="policy-date-picker"></mat-datepicker>
        </mat-form-field>
      </div>

      <div *ngIf="extra.type === 'location'">
        <mat-form-field class="form-field-stretch" color="accent">
          <mat-label>Location</mat-label>
          <mat-icon matPrefix>public</mat-icon>
          <input matInput [(ngModel)]="extra.locationValue" (ngModelChange)="onAdditionalRestrictionChange()" placeholder="Location" />
        </mat-form-field>
      </div>

      <div *ngIf="extra.type === 'purpose'">
        <mat-form-field class="form-field-stretch" color="accent">
          <mat-label>Purpose</mat-label>
          <mat-icon matPrefix>flag</mat-icon>
          <input matInput [(ngModel)]="extra.purposeValue" (ngModelChange)="onAdditionalRestrictionChange()" placeholder="Purpose" />
        </mat-form-field>
      </div>
    </div>

    <button mat-flat-button color="accent" type="button" (click)="addRestriction()">
      <mat-icon>add_circle</mat-icon>
      Add permission restriction
    </button>
  </div>

  <!-- JSON (por defecto) -->
  <div style="display: flex; flex-direction: column; gap: 16px;" *ngIf="restrictionType === 'json' || !restrictionType">
    <!--  Permissions -->
    <mat-form-field class="form-field-stretch" color="accent" id="form-field-permissions">
      <mat-label>Permissions (JSON)</mat-label>
      <mat-icon matPrefix>rule</mat-icon>
      <textarea #permissionsTextarea class="json-textarea" [(ngModel)]="permissionsJson" (input)="autoResize(permissionsTextarea)" matInput></textarea>
    </mat-form-field>
  </div>

  <!-- Prohibitions restriction type -->
  <mat-form-field class="form-field-stretch" color="accent">
    <mat-label>Prohibitions</mat-label>
    <mat-icon matPrefix>block</mat-icon>
    <mat-select [(ngModel)]="prohibitionRestrictionType" (ngModelChange)="onProhibitionRestrictionTypeChange()">
      <mat-option value="none">None</mat-option>
      <mat-option value="temporal">Temporal range</mat-option>
      <mat-option value="location">Location</mat-option>
      <mat-option value="purpose">Purpose</mat-option>
      <mat-option value="json">JSON</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Prohibitions temporal range -->
  <div *ngIf="prohibitionRestrictionType === 'temporal'" style="display: flex; gap: 16px;">
    <mat-form-field class="form-field-half" color="accent">
      <mat-label>Start date</mat-label>
      <mat-icon matPrefix>event</mat-icon>
      <input matInput [matDatepicker]="startPickerProhibition" [(ngModel)]="prohibitionTemporalStart" (ngModelChange)="onProhibitionTemporalRangeChange()" placeholder="Start date" readonly (click)="startPickerProhibition.open()" (keydown)="$event.preventDefault()">
      <mat-datepicker #startPickerProhibition panelClass="policy-date-picker"></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="form-field-half" color="accent">
      <mat-label>End date</mat-label>
      <mat-icon matPrefix>event_busy</mat-icon>
      <input matInput [matDatepicker]="endPickerProhibition" [(ngModel)]="prohibitionTemporalEnd" (ngModelChange)="onProhibitionTemporalRangeChange()" placeholder="End date" readonly (click)="endPickerProhibition.open()" (keydown)="$event.preventDefault()">
      <mat-datepicker #endPickerProhibition panelClass="policy-date-picker"></mat-datepicker>
    </mat-form-field>
  </div>

  <!-- Prohibitions location -->
  <div *ngIf="prohibitionRestrictionType === 'location'">
    <mat-form-field class="form-field-stretch" color="accent">
      <mat-label>Location</mat-label>
      <mat-icon matPrefix>public</mat-icon>
      <input matInput [(ngModel)]="prohibitionLocationValue" (ngModelChange)="onProhibitionLocationChange()" placeholder="Location" />
    </mat-form-field>
  </div>

  <!-- Prohibitions purpose -->
  <div *ngIf="prohibitionRestrictionType === 'purpose'">
    <mat-form-field class="form-field-stretch" color="accent">
      <mat-label>Purpose</mat-label>
      <mat-icon matPrefix>flag</mat-icon>
      <input matInput [(ngModel)]="prohibitionPurposeValue" (ngModelChange)="onProhibitionPurposeChange()" placeholder="Purpose" />
    </mat-form-field>
  </div>

  <!-- Additional prohibitions (solo para modo no JSON) -->
  <div *ngIf="prohibitionRestrictionType !== 'json'" style="display: flex; flex-direction: column; gap: 12px;">
    <div *ngFor="let extra of additionalProhibitions; let i = index" style="display: flex; flex-direction: column; gap: 12px; padding: 12px; border: 1px solid rgba(148, 163, 184, 0.35); border-radius: 16px;">
      <div style="display: flex; gap: 12px; align-items: center;">
        <mat-form-field class="form-field-stretch" color="accent" style="margin: 0;">
          <mat-label>Prohibition {{ i + 2 }} type</mat-label>
          <mat-icon matPrefix>tune</mat-icon>
          <mat-select [(ngModel)]="extra.type" (ngModelChange)="onAdditionalProhibitionTypeChange(i)">
            <mat-option value="none">None</mat-option>
            <mat-option value="temporal">Temporal range</mat-option>
            <mat-option value="location">Location</mat-option>
            <mat-option value="purpose">Purpose</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="icon-btn">
          <button class="icon-button" mat-stroked-button color="warn" type="button" (click)="removeProhibitionRestriction(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="extra.type === 'temporal'" style="display: flex; gap: 12px;">
        <mat-form-field class="form-field-half" color="accent">
          <mat-label>Start date</mat-label>
          <mat-icon matPrefix>event</mat-icon>
          <input matInput [matDatepicker]="startPickerProhibitionExtra" [(ngModel)]="extra.temporalStart" (ngModelChange)="onAdditionalProhibitionChange()" placeholder="Start date" readonly (click)="startPickerProhibitionExtra.open()" (keydown)="$event.preventDefault()">
          <mat-datepicker #startPickerProhibitionExtra panelClass="policy-date-picker"></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="form-field-half" color="accent">
          <mat-label>End date</mat-label>
          <mat-icon matPrefix>event_busy</mat-icon>
          <input matInput [matDatepicker]="endPickerProhibitionExtra" [(ngModel)]="extra.temporalEnd" (ngModelChange)="onAdditionalProhibitionChange()" placeholder="End date" readonly (click)="endPickerProhibitionExtra.open()" (keydown)="$event.preventDefault()">
          <mat-datepicker #endPickerProhibitionExtra panelClass="policy-date-picker"></mat-datepicker>
        </mat-form-field>
      </div>

      <div *ngIf="extra.type === 'location'">
        <mat-form-field class="form-field-stretch" color="accent">
          <mat-label>Location</mat-label>
          <mat-icon matPrefix>public</mat-icon>
          <input matInput [(ngModel)]="extra.locationValue" (ngModelChange)="onAdditionalProhibitionChange()" placeholder="Location" />
        </mat-form-field>
      </div>

      <div *ngIf="extra.type === 'purpose'">
        <mat-form-field class="form-field-stretch" color="accent">
          <mat-label>Purpose</mat-label>
          <mat-icon matPrefix>flag</mat-icon>
          <input matInput [(ngModel)]="extra.purposeValue" (ngModelChange)="onAdditionalProhibitionChange()" placeholder="Purpose" />
        </mat-form-field>
      </div>
    </div>

    <button mat-flat-button color="accent" type="button" (click)="addProhibitionRestriction()">
      <mat-icon>add_circle</mat-icon>
      Add prohibition restriction
    </button>
  </div>

  <!-- Prohibitions JSON (por defecto) -->
  <div style="display: flex; flex-direction: column; gap: 16px;" *ngIf="prohibitionRestrictionType === 'json' || !prohibitionRestrictionType">
    <mat-form-field class="form-field-stretch" color="accent" id="form-field-prohibitions">
      <mat-label>Prohibitions (JSON)</mat-label>
      <mat-icon matPrefix>block</mat-icon>
      <textarea #prohibitionsTextarea class="json-textarea" [(ngModel)]="prohibitionsJson" (input)="autoResize(prohibitionsTextarea)" matInput></textarea>
    </mat-form-field>
  </div>
  <!--  Obligations -->
  <mat-form-field class="form-field-stretch" color="accent" id="form-field-obligations">
    <mat-label>Obligations (JSON)</mat-label>
    <mat-icon matPrefix>task_alt</mat-icon>
    <textarea #obligationsTextarea class="json-textarea" [(ngModel)]="obligationsJson" (input)="autoResize(obligationsTextarea)" matInput></textarea>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions>
  <button color="warn" mat-dialog-close="true" mat-stroked-button>
    <mat-icon>cancel</mat-icon>
    Cancel
  </button>

  <button (click)="onSave()" *ngIf="editMode" color="accent" mat-flat-button >
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button (click)="onSave()" *ngIf="!editMode" color="accent" mat-flat-button>
    <mat-icon>add_circle</mat-icon>
    Create
  </button>
</mat-dialog-actions>
